import React from 'react';

import { auth } from '../../utils/authService';
import { ErrorFlash } from '../../components';

export default class LoginView extends React.Component {
  state = {
    errors: null,
  };

  // properties
  subscription = null;

  // events
  handleAuthError = (errors) => {
    this.setState({ errors: errors });
  };

  // lifecycle
  componentWillMount() {
    this.subscription = auth.subscribe('auth_error', this.handleAuthError);
  }

  componentWillUnmount() {
    if (this.subscription) {
      this.subscription.stop();
    }
  }

  render() {
    const errors = this.state.errors || {};

    return (
      <div className="login">
        <ErrorFlash errors={errors.error} message={errors.error_description} />
        <h2>NEX Crossing CMS</h2>
        <button onClick={auth.login.bind(this)}>Sign In</button>
      </div>
    );
  }
}
